/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Switch, Modal, Tooltip, Empty, Spin } from "antd";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";
import CustomLoader from "../../components/loader";
import { roomDurationSchema } from "../../schema/addQueue";
import Inputlayer from "../../components/FormComponent/Input";
import { CloseOutlined } from '@ant-design/icons';
import { EditOutlined } from '@ant-design/icons';
import { EyeOutlined } from '@ant-design/icons';
import { CheckOutlined } from '@ant-design/icons';


const $ = require("jquery");
class QueueListConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      list: [],
      switchLoading: false,
      message: "",
      isLoading: false,
      visible: false,
      formData: [],
    };
  }
  componentDidMount() {
  
    this.fetchData();
    setTimeout(function () {
      if (
        $(".body-container").outerHeight(true) + $("header").outerHeight(true) >
        $(window).height()
      ) {
        $("footer").css({ position: "relative", top: "57px" });
      } else {
        $("footer").css({ position: "fixed", top: "unset" });
      }
    }, 100);
    let formSchema = Object.assign({}, roomDurationSchema);
    formSchema["feilds"].map((feild, key) => {
      formSchema["feilds"][key]["value"] = null;
      formSchema["feilds"][key]["valid"] = false;
      formSchema["feilds"][key]["errors"] = [];
      delete formSchema["feilds"][key]["text"];
    });
    this.setState({ formData: formSchema["feilds"] });
  }
  componentWillUnmount() {
  
    $("footer").css({ position: "fixed", top: "unset" });
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    return prevProps;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    setTimeout(function () {
      if (
        $(".body-container").outerHeight(true) + $("header").outerHeight(true) >
        $(window).height()
      ) {
        $("footer").css({ position: "relative", top: "57px" });
      } else {
        $("footer").css({ position: "fixed", top: "unset" });
      }
    }, 100);
    if (snapshot !== null || snapshot !== undefined) {
      if (snapshot.location.pathname !== this.props.location.pathname) {
        this.fetchData();
      }
    }
  }

  fetchData() {
    const { getQueueList } = networkList;
    this.setState({ isLoading: true });
    postService(getQueueList, "GET", "null").then((res) => {
      console.info("came", res);
      if (res.status) {
        this.setState((state) => ({
          list: res.data,
          message: res.message,
          isLoading: false,
        }));
        return true;
      }
    });

    console.log(this.props);
  }
  onChange(value) {
    console.log(`selected ${value}`);
  }

  onChangeDate(date, dateString) {
    console.log(date, dateString);
  }

  onBlur() {
    console.log("blur");
  }

  onFocus() {
    console.log("focus");
  }

  onSearch(val) {
    console.log("search:", val);
  }
  addQueue() {
    console.clear();

    this.props.history.push("/queue/add");
  }
  editQueue(data) {
    console.clear();

    this.props.history.push("/queue/edit?qid=" + data["queue_list_id"]);
  }
  viewQueue(data) {
    console.clear();
    this.props.history.push("/queue/view?qid=" + data["queue_list_id"]);
  }

  queueSwitchChange(status, id, index) {
    const { queueStatusChange } = networkList;
    this.setState({ switchLoading: true, isLoading: true });
    try {
      postService(queueStatusChange, "POST", {
        id: id,
        status: status ? "1" : "0",
      }).then((res) => {
        if (res.status) {
          this.setState({ isLoading: false });
          // Modal.success({
          //     title: 'Success',
          //     content: res.message
          // });
          this.fetchData();
        } else {
          this.setState({ isLoading: false });
          Modal.error({
            title: "Failure",
            content: res.message,
          });
        }
      });
    } catch (error) {
    
      this.setState({ isLoading: false });
      Modal.error({
        title: "Failure",
        content: "Oops, something went wrong... Please try again.",
      });
    }
  }
  // earliestSwitchChange(status, id, index) {
  //   const { earliestAlgStatusChange } = networkList;
  //   this.setState({ isLoading: true });
  //   try {
  //     postService(earliestAlgStatusChange, "POST", {
  //       id: id,
  //       status: status ? "1" : "0",
  //     }).then((res) => {
  //       if (res.status) {
  //         // Modal.success({
  //         //     title: 'Success',
  //         //     content: res.message
  //         // });
  //         this.setState({ isLoading: false });
  //         this.fetchData();
  //       } else {
  //         Modal.error({
  //           title: "Failure",
  //           content: res.message,
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     this.setState({ isLoading: false });
  //     Modal.error({
  //       title: "Failure",
  //       content: "Oops, something went wrong... Please try again.",
  //     });
  //   }
  //   this.setState({ switchLoading: false });
  // }
  // payerSwitchChange(status, id, index) {
  //   const { payertypeAlgStatusChange } = networkList;
  //   this.setState({ isLoading: true });
  //   try {
  //     postService(payertypeAlgStatusChange, "POST", {
  //       id: id,
  //       status: status ? 1 : 0,
  //     }).then((res) => {
  //       if (res.status) {
  //         // Modal.success({
  //         //     title: 'Success',
  //         //     content: res.message
  //         // });
  //         this.setState({ isLoading: false });
  //         this.fetchData();
  //       } else {
  //         Modal.error({
  //           title: "Failure",
  //           content: res.message,
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     this.setState({ isLoading: false });
  //     Modal.error({
  //       title: "Failure",
  //       content: "Oops, something went wrong... Please try again.",
  //     });
  //   }
  //   this.setState({ switchLoading: false });
  // }
  showModal = (item) => {
    var queue_id = item.queue_list_id;
    var room_percentage = parseInt(item.room_duration_percentage);

    this.setState(
      (state) => ({
        room_percentage: room_percentage,
        queue_id: queue_id,
        visible: true,
      }),
      () => {
        var formFeilds = this.state.formData;
        formFeilds.map((feild, key) => {
          if (feild["name"] === "roomduration") {
            formFeilds[key]["value"] = room_percentage.toString();
            formFeilds[key]["valid"] = true;
          }
        });
        this.setState((state) => ({ formData: formFeilds }));
      }
    );
  };

  setModalVisible(modalVisible) {
    this.setState(
      (state) => ({ visiable: modalVisible }),
      () => {
        // this.tableHeadrender();
      }
    );
  }
  handleFormInputChange(evnt) {
  
    var formFeilds = this.state.formData;
    formFeilds.map((feild, key) => {
      if (feild["name"] === evnt["name"]) {
        formFeilds[key]["value"] = evnt["value"];
        formFeilds[key]["valid"] = true;
        this.setState({ room_percentage: evnt["value"] });
      }
    });
    this.setState(
      (state) => ({ formData: formFeilds }),
      () => {
        this.validateModalFeilds(this.state.formData);
      }
    );
  }
  validateModalFeilds(formFeilds) {
    let errors = [];
    formFeilds.map((feild, key) => {
      if (feild["element"] === "input" || feild["element"] === "select2") {
        formFeilds[key]["errors"] = [];
        if (!feild.disable) {
          feild.rules.map((rule, rkey) => {
            if (
              rule.test !== undefined &&
              typeof rule.test === "function" &&
              !rule.test(feild["value"])
            ) {
              formFeilds[key]["errors"].push({ message: rule.message });
              errors.push(false);
            }
          });
        }
      }
    });
    this.setState((state) => ({ formData: formFeilds }));
    return errors;
  }
  editData() {
    var formFeilds = this.state.formData;
    let errors = this.validateModalFeilds(formFeilds);
  
    const { roomDurationPercentageChange } = networkList;
    let payload = {
      queue_list_id: this.state.queue_id,
      room_duration_percentage: parseInt(this.state.room_percentage),
    };
  
    if (!errors.includes(false)) {
      postService(roomDurationPercentageChange, "POST", payload).then((res) => {
        if (res.status) {
          let This = this;
          Modal.success({
            zIndex: 1500,
            maskClosable: false,
            title: "Success",
            content: res.message ? res.message : "Updated Successfully",
            onOk() {
              This.fetchData();
              This.setState({ visible: false });
            },
          });
        }
      });
    }
  }
  render() {
    const { id, slug } = this.props.match.params;
    let { list, message, isLoading } = this.state;
    let tableHead = [
      // { key: "technician_name", label: "Technician" },
      { key: "unitname", label: "Unit Name" },
      { key: "work_station_name", label: "Work Station" },
      { key: "room_name", label: "Room Name" },
      { key: "operator_name", label: "Operator" },
      { key: "queue_type", label: "Queue Type" },
      // { key: "room_duration_percentage", label: "Room Duration" },
      { key: "status", label: "Status" },
      { key: "actions", label: "Actions" },
    ];

    let premissions = {};
    const { menuList } = this.props;
  
    menuList.map((menu, key) => {
      if (id === menu["route"]) {
        menu["submenu"].map((smenu, skey) => {
          if (slug === smenu["route"]) {
            premissions = smenu["permissions"];
          }
        });
      }
    });
    return (
      <div className="p-4 qConfigScroll">
        {console.log("q list", list)}
        {isLoading && <CustomLoader />}
        {premissions["add"] === "true" && (
          // <div className="card p-4">
          <form>
            <div className="row">
              {/* <div className="col d-none">
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Select a Unit"
                    optionFilterProp="children"
                    onChange={this.onChange.bind()}
                    onFocus={this.onFocus.bind()}
                    onBlur={this.onBlur.bind()}
                    onSearch={this.onSearch.bind()}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="rch1">RCH1</Option>
                    <Option value="rch2">RCH2</Option>
                    <Option value="rch3">RCH3</Option>
                  </Select>
                </div>
                <div className="col d-none">
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Select a Departement"
                    optionFilterProp="children"
                    onChange={this.onChange.bind()}
                    onFocus={this.onFocus.bind()}
                    onBlur={this.onBlur.bind()}
                    onSearch={this.onSearch.bind()}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="jack">Radiology</Option>
                    <Option value="lucy">Pharma</Option>
                    <Option value="tom">Laborotory</Option>
                  </Select>
                </div>
                <div className="col d-none">
                  <Select
                    showSearch
                    style={{
                      width: "100%",
                    }}
                    placeholder="Select a Service Group"
                    optionFilterProp="children"
                    onChange={this.onChange.bind()}
                    onFocus={this.onFocus.bind()}
                    onBlur={this.onBlur.bind()}
                    onSearch={this.onSearch.bind()}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="jack">X-ray</Option>
                    <Option value="lucy">CT-Scan</Option>
                    <Option value="tom">MRI</Option>
                  </Select>
                </div> */}
              {premissions["add"] === "true" && (
                <div className="col-12">
                  <div className="row justify-content-end appointement-screen queeadd">
                    <div className="col-6 text-right">
                      <button
                        type="button"
                        onClick={this.addQueue.bind(this)}
                        style={{ backgroundColor: "#6c3964" }}
                      >
                        <img src="/assets/images/icons/queueStack.png" alt="" />
                        Add Queue
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
          // </div>
        )}
        {/* table */}
        <Spin spinning="">
          <div className="card mt-2 mb-3 card-table">
            <div
              className="financial-table table-responsive sticky-header"
              id="table"
            >
              <table className="table table-hover table-bordered mb-0 bg-white">
                <thead>
                  <tr>
                    <td className="text-capitalize align-middle">S.No.</td>
                    {tableHead.map((head, key) => {
                     return (
                      <td className="text-capitalize align-middle" key={key}>
                        {head["label"]}
                      </td>
                    );
                    })}
                  </tr>
                </thead>
                {list.length ? (
                  <tbody>
                    {list.map((body, key) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          {tableHead.map((head, Hkey) => {
                            if (head["key"] === "room_name") {
                              return (
                                <td key={Hkey}>
                                  {body["room_name"] ? body.room_name : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "operator_name") {
                              return (
                                <td key={Hkey}>
                                  {body["operator_name"]
                                    ? body.operator_name
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "technician_name") {
                              return (
                                <td key={Hkey}>
                                  {body["technician_name"]
                                    ? body.technician_name
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "work_station_name") {
                              return (
                                <td key={Hkey}>
                                  {body["work_station_name"]
                                    ? body.work_station_name
                                    : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "unitname") {
                              return (
                                <td key={Hkey} style={{minWidth: "200px"}}>
                                  {body["unitname"] ? body.unitname : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "queue_type") {
                              return (
                                <td key={Hkey}>
                                  {body["queue_type"] ? body.queue_type : "NA"}
                                </td>
                              );
                            }
                            if (head["key"] === "room_duration_percentage") {
                              return (
                                <td key={Hkey}>
                                  <p className="text-p-bold mb-0">
                                    {body.room_duration_percentage ||
                                    body.room_duration_percentage == 0
                                      ? body.room_duration_percentage + `%`
                                      : "NA"}
                                    {premissions["edit"] === "true" && (
                                      <Tooltip title="Edit">
                                        {/* <Icon
                                          type="edit"
                                          className="pl-2"
                                          onClick={() => this.showModal(body)}
                                        /> */}
                                       

<EditOutlined className="pl-2" onClick={() => this.showModal(body)} />

                                      </Tooltip>
                                    )}
                                  </p>
                                </td>
                              );
                            }
                            if (head["key"] === "status") {
                              return (
                                <td key={Hkey} style={{width: "40px"}}>
                                  <Switch
                                    // checkedChildren={<Icon type="check" />}
                                    checkedChildren={<CheckOutlined />}
                                    // unCheckedChildren={<Icon type="close" />}
                                    unCheckedChildren={

                                    <CloseOutlined />
                                    }
                                    checked={parseInt(body.status)}
                                    onChange={(status) =>
                                      this.queueSwitchChange(
                                        status,
                                        body.id,
                                        key
                                      )
                                    }
                                  />
                                </td>
                              );
                            }
                            if (head["key"] === "actions") {
                              return (
                                <td key={Hkey}>
                                  <div className="row">
                                    {premissions["view"] === "true" && (
                                      <div className="col-3 pr-0">
                                        <Tooltip title="View">
                                          {/* <Icon
                                            type="eye"
                                            onClick={this.viewQueue.bind(
                                              this,
                                              body
                                            )}
                                          /> */}
                                         

<EyeOutlined onClick={() => this.viewQueue(body)} />

                                        </Tooltip>
                                      </div>
                                    )}
                                    {premissions["edit"] === "true" && (
                                      <div className="col-3 pr-0">
                                        <Tooltip title="Edit">
                                          {/* <Icon
                                            type="edit"
                                            onClick={this.editQueue.bind(
                                              this,
                                              body
                                            )}
                                          /> */}
                                         

<EditOutlined onClick={() => this.editQueue(body)} />

                                        </Tooltip>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              );
                            }
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="13" className="text-center">
                        <img src="/assets/images/icons/no-data.svg" alt="" />
                        <p className="no-data mb-0">No Data</p>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </Spin>

        {/* {list.map((data, key) => {
          return (
            <div className="card mt-3 queue-config-list py-3" key={key}>
              <div className="row"> */}
        {/* <div className="col-md-1 my-auto">
                  <p className="number-p-center mb-0">{key + 1}</p>
                </div>
                <div
                  className={
                    premissions["edit"] === "true" ? "col-md-7" : "col-md-9"
                  }
                  // className="col-md-8"
                >
                  <div className="row">
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Room Name</p>
                      <p className="text-p-bold mb-0">
                        {" "}
                        {data.room_name ? data.room_name : "NA"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Operator</p>
                      <p className="text-p-bold mb-0">
                        {" "}
                        {data.operator_name ? data.operator_name : "NA"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Technician</p>
                      <p className="text-p-bold mb-0">
                        {" "}
                        {data.technician_name ? data.technician_name : "NA"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Unit Name</p>
                      <p className="text-p-bold mb-0">
                        {" "}
                        {data.unitname ? data.unitname : "NA"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Queue Type</p>
                      <p className="text-p-bold mb-0">
                        {" "}
                        {data.queue_type ? data.queue_type : "NA"}
                      </p>
                    </div>
                    <div className="col-md-2">
                      <p className="text-p-light mb-0">Room Duration</p>
                      <p className="text-p-bold mb-0">
                        {data.room_duration_percentage ||
                        data.room_duration_percentage == 0
                          ? data.room_duration_percentage + `%`
                          : "NA"}
                        {premissions["edit"] === "true" && (
                          <Tooltip title="Edit">
                            <Icon
                              type="edit"
                              className="pl-2"
                              onClick={() => this.showModal(data)}
                            />
                          </Tooltip>
                        )}
                      </p>
                    </div>
                  </div>
                </div> */}
        {/* <div
                  className={
                    premissions["edit"] === "true" ? "col-md-4" : "col-md-2"
                  }
                  // className="col-md-3"
                > */}
        {/* <div className="row">
                    <div className="col">
                      <p className="text-p-light mb-0">Status</p>
                      <p className="mb-0">
                        <Switch
                          checkedChildren={<Icon type="check" />}
                          unCheckedChildren={<Icon type="close" />}
                          checked={parseInt(data.status)}
                          onChange={(status) =>
                            this.queueSwitchChange(status, data.id, key)
                          }
                        />
                      </p>
                    </div> */}
        {/* previous commented */}
        {/* {premissions["edit"] === "true" && ( */}
        {/* <div className="col">
                      <p className="text-p-light mb-0">Earliest Slot</p>
                      <p className="mb-0">
                        <Switch
                          checkedChildren={<Icon type="check" />}
                          unCheckedChildren={<Icon type="close" />}
                          checked={parseInt(data.earliest_slot_alg)}
                          onChange={(earliest_slot_alg) =>
                            this.earliestSwitchChange(
                              earliest_slot_alg,
                              data.id,
                              key
                            )
                          }
                        />
                      </p>
                    </div> */}
        {/* )} */}
        {/* {premissions["edit"] === "true" && ( */}
        {/* <div className="col">
                      <p className="text-p-light mb-0">Payer Type</p>
                      <p className="mb-0">
                        <Switch
                          checkedChildren={<Icon type="check" />}
                          unCheckedChildren={<Icon type="close" />}
                          checked={parseInt(data.payertype_slot_alg)}
                          onChange={(payertype_slot_alg) =>
                            this.payerSwitchChange(
                              payertype_slot_alg,
                              data.id,
                              key
                            )
                          }
                        />
                      </p>
                    </div> */}
        {/* )} */}
        {/* previous commented */}

        {/* <div className="col">
                      <p className="text-p-light mb-0">Actions</p>
                      <div className="row">
                        {premissions["view"] === "true" && (
                          <div className="col-3 pr-0">
                            <Tooltip title="View">
                              <Icon
                                type="eye"
                                onClick={this.viewQueue.bind(this, data)}
                              />
                            </Tooltip>
                          </div>
                        )}
                        {premissions["edit"] === "true" && (
                          <div className="col-3 pr-0">
                            <Tooltip title="Edit">
                              <Icon
                                type="edit"
                                onClick={this.editQueue.bind(this, data)}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </div> */}
        {/* </div> */}
        {/* </div>
              </div>
            </div>
          );
        })} */}

        {list.length == 0 && message && (
          <Empty
            className="pt-5 mt-5"
            description={<p className="text-capitalize">{message}</p>}
          />
        )}
        <Modal
          title=""
          centere
          className="admin-addform"
          footer={null}
          width="40%"
          zIndex="1200"
          closable={false}
          destroyOnClose={true}
          maskClosable={false}
          visible={this.state.visible}
        >
          <div className="p-5">
            <h4 className="text-center">Update Room Duration %</h4>
            <div className="row">
              {/* <Icon
                type="close"
                className=" popup-close"
                onClick={() => this.setState({ visible: false })}
              /> */}
           

<CloseOutlined className="popup-close" onClick={() => this.setState({ visible: false })} />

              <div className="col-12 position-relative form-block py-4">
                {/* <form noValidate> */}
                {this.state.formData.map((feild, key) => {
                  if (feild.element === "input") {
                    return (
                      <div className="row mb-4" key={key}>
                        <div className="col-8 w-100 mx-auto">
                          <Inputlayer
                            {...this.props}
                            {...this.state}
                            key={key}
                            feildData={feild}
                            onInputChanges={this.handleFormInputChange.bind(
                              this
                            )}
                          />
                        </div>
                      </div>
                    );
                  }
                })}
                {/* </form> */}
              </div>
            </div>

            <div className="mb-4 text-center">
              <button
                type="button"
                className="btn btn-danger mr-3"
                onClick={() => {
                  this.editData();
                }}
              >
                Update
              </button>
              {/* <button type="button" className="btn btn-danger" onClick={() => { this.setState({ visible: false }) }}>Cancel</button> */}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default QueueListConfig;
